<i18n>
{
  "de": {
    "or": "oder"
  },
  "en": {
    "or": "or"
  }
}
</i18n>

<template>
  <no-ssr>
    <div v-if="!isAuthenticated">
      <div class="social-button-container mt-10">
        <div class="social-button">
          <vue-facebook-login
            v-if="!showRegistrationForm"
            v-model="fbModel"
            tabindex="1"
            app-id="235969604174559"
            :login-options="{ scope: 'email' }"
            @login="handleLogin"
            @sdk-init="handleFacebookSdkInit"
          />
        </div>
        <div class="social-button">
          <google-login-button
            v-if="!showRegistrationForm"
            tabindex="2"
            clientId="79115176131-a6rbi8sl5hg30sm6s6rdtkjht0adbfh7.apps.googleusercontent.com"
            @success="handleLogin"
            @failure="handleGoogleFailure"
          />
        </div>
      </div>

      <socialRegistrationForm
        v-if="showRegistrationForm"
        :modalRegistration="modalRegistration"
        :user="user"
        @valid="submitRegistration"
        @cancelled="cancelRegistration"
      />

      <div
        v-if="divider && !showRegistrationForm"
        class="is-divider mb-20"
        :data-content="$t('or')"
      />
    </div>
    <div v-else />
  </no-ssr>
</template>

<script>
import socialRegistrationForm from '~/components/social-registration-form'
import googleLoginButton from '~/components/google-login-button'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'facebookLoginComponent',
  serverCacheKey: () => 'social-login',
  props: ['from', 'params', 'divider', 'modalRegistration'],
  components: { googleLoginButton, socialRegistrationForm },
  data: () => ({
    user: null,
    showRegistrationForm: false,
    fbModel: {},
    fbScope: {},
    accessToken: false,
    authType: false
  }),

  async mounted() {
    if (!this.isAuthenticated) {
      this.logoutSocialAccounts()
    }
  },
  computed: {
    apiEndpoint() {
      if (this.authType === 'facebook') {
        return '/api/private/authenticateFacebook'
      }
      if (this.authType === 'google') {
        return '/api/private/authenticateGoogle'
      }
      return ''
    },
    ...mapState(['artist', 'isAuthenticated'])
  },
  methods: {
    ...mapActions(['login', 'storeReturnRouteObject', 'storeRedirectPath', 'refreshSinglePost']),
    async submitRegistration(data) {
      const result = await this.apiPost(this.apiEndpoint, {
        access_token: this.accessToken,
        email: data.email,
        nickname: data.nickname,
        updated: true
      })
      if (result) {
        this.submitLogin(result)
      }
    },
    logoutSocialAccounts() {
      // google needs no logout: the GIS token flow keeps no client-side session
      if (this.authType === 'facebook') {
        if (this.fbScope) this.fbScope.logout()
      }
    },

    async cancelRegistration() {
      this.logoutSocialAccounts()
      this.$root.$emit('logout')
      this.showRegistrationForm = false
      this.$emit('cancelled', false)
      this.$emit('registration', false)
    },
    async submitLogin(data) {
      data.from = this.from

      if (this.$route.query.redirect) {
        this.storeRedirectPath(this.$route.query.redirect)
      }

      if (this.params && this.params.returnRouteObject) {
        this.storeReturnRouteObject(this.params.returnRouteObject)
      }

      const navigationHandled = await this.login(data)

      if (this.params && this.params.onPost) {
        // this.$root.$emit('refetchSinglePost')
        this.$root.$emit('refreshAPI', { force: true })
        await this.refreshSinglePost({ urlAlias: this.artist.urlAlias })
        return
      }

      // Only reload if navigation wasn't fully handled by window.location methods
      if (!navigationHandled && window) {
        window.location.reload()
      }
    },
    async queryAuthentication(data) {
      if (!data) return false
      if (data.status === 'connected' && data.authResponse) {
        this.authType = 'facebook'
        this.accessToken = data.authResponse.accessToken
        return this.apiPost(this.apiEndpoint, {
          access_token: this.accessToken
        })
      }
      // GIS token client response: a plain { access_token, ... } object
      if (data.access_token) {
        this.authType = 'google'
        this.accessToken = data.access_token
        return this.apiPost(this.apiEndpoint, {
          access_token: this.accessToken
        })
      }
      return false
    },
    handleGoogleFailure(data) {
      console.log('google failure', data)
    },
    async handleLogin(data) {
      const authData = await this.queryAuthentication(data)
      if (!authData || !authData.user) return false

      if (
        !authData.user.socialData.nickname &&
        !authData.user.socialData.email
      ) {
        this.showRegistrationForm = false

        this.logoutSocialAccounts()

        return this.submitLogin(authData)
      }
      // newly registered account (confirm fields)
      this.user = authData.user

      this.showRegistrationForm = true
      this.$emit('registration', true)
    },
    async handleFacebookSdkInit(data) {
      this.FB = data.FB
      this.fbScope = data.scope
      if (!this.isAuthenticated) {
        data.scope.logout()
      }
    }
  }
}
</script>
<style lang="scss">
.social-button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .social-button {
    max-width: 215px;
    width: 215px;

    .v-facebook-login {
      span {
        white-space: nowrap !important;
      }
    }
  }

  .social-button+.social-button {
    margin-top: 10px;
  }

  @media screen and (min-width: 478px) {
    .social-button+.social-button {
      margin-top: 0px;
    }
  }
}

@media screen and (min-width: 450px) {
  .modal-card {
    .social-button+.social-button {
      margin-top: 0px !important;
    }
  }
}

.abcRioButton {
  box-shadow: 0px !important;
  border-radius: 4px !important;

  .abcRioButtonIcon {
    padding-left: 18px !important;
    padding-right: 0px !important;
  }
}
</style>
